function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ProcessTabs from "segments/desktop/core-components/process-tabs/process-tabs";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { XS } from "constants/sizes";
import VerticalTimerTabs from "segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs";
import Title from "segments/desktop/core-components/title/title";
const DEFAULT_TAB_CONTENT = {
    topic: {},
    title: null
};
const SideBySideTabsAndProcessTabs = (_param)=>{
    var { tabContent, title, advancedTitleConfig, advancedProcessTabs } = _param, rest = _object_without_properties(_param, [
        "tabContent",
        "title",
        "advancedTitleConfig",
        "advancedProcessTabs"
    ]);
    const contentRenderer = (contentObject)=>/*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, DEFAULT_TAB_CONTENT, contentObject, tabContent), {
            titleSize: XS
        }));
    const processRenderer = ({ processTab })=>/*#__PURE__*/ _jsx("div", {
            className: "process-tabs",
            children: /*#__PURE__*/ _jsx(ProcessTabs, _object_spread({}, processTab, advancedProcessTabs))
        });
    const { titleMargin } = title, titleProps = _object_without_properties(title, [
        "titleMargin"
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "side-by-side-tabs-and-process-tabs-component",
        children: [
            (titleProps === null || titleProps === void 0 ? void 0 : titleProps.title) && /*#__PURE__*/ _jsx("div", {
                className: "title-wrapper",
                style: {
                    marginBottom: titleMargin
                },
                children: /*#__PURE__*/ _jsx(Title, _object_spread({
                    titleClassName: "main-title"
                }, titleProps))
            }),
            /*#__PURE__*/ _jsx(VerticalTimerTabs, _object_spread_props(_object_spread({}, rest), {
                title: advancedTitleConfig,
                tabContentRenderer: contentRenderer,
                rightSideRenderer: processRenderer,
                tabsContainerClassName: "tabs-container"
            }))
        ]
    });
};
export default SideBySideTabsAndProcessTabs;
